function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "harvest",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  fill: "#C4C4C4",
  stroke: "#E6E8EA"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#harvest)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.334 4V7.33333",
  stroke: "#E6E8EA",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.334 17.3334V20.6667",
  stroke: "#E6E8EA",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.44141 6.44165L8.79974 8.79998",
  stroke: "#E6E8EA",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.8672 15.8667L18.2255 18.225",
  stroke: "#E6E8EA",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 12.3334H7.33333",
  stroke: "#E6E8EA",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.334 12.3334H20.6673",
  stroke: "#E6E8EA",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.44141 18.225L8.79974 15.8667",
  stroke: "#E6E8EA",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.8672 8.79998L18.2255 6.44165",
  stroke: "#E6E8EA",
  strokeWidth: 2
}));

var SvgHarvest = function SvgHarvest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHarvest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/harvest.e3e9c533.svg";
export { ForwardRef as ReactComponent };